<template>
  <div class="wrapper">
    <div class="photo-container">
      <div v-if="situation && situation.media">
        <img v-if="filename" :src="filename" class="photo" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Video',
  computed: {
    //get the current situation
    situation() {
      return this.$store.getters.getSituationById(this.$route.params.idSituation)[0];
    },
    filename() {
      if (!this.$parent.onOff) {
        return require('../../../../public/demo/specific/' + 'On' + this.situation.media.filename);
      } else {
        return require('../../../../public/demo/specific/' + 'Off' + this.situation.media.filename);
      }
    },
  },
};
</script>

<style scoped>
.wrapper {
  width: 100%;
}
.photo-container {
  margin: auto;
  position: relative;
}

.photo {
  width: 100%;
}
</style>
